import {BASE_PATH_API, TIMEOUT_TIME, STAGE_DIRNAME, BASE_PATH_API_DEV} from 'constants/general'
import axios from 'axios'
import { decodeStorage } from 'functions/storageBase64'

export async function getCardAssociate(){
    const apiURL = `${BASE_PATH_API}/credito-sears/v1/cards`
    const access_token = decodeStorage('access_token')
    //const sears_numero_internet = decodeStorage('sears_numero_internet')
    const sears_numero_internet = 'undefined'

    let config
    if(sears_numero_internet && sears_numero_internet != 'undefined'){
        config = {
            method: 'get',
            url: apiURL,
            timeout: TIMEOUT_TIME,
            withCredentials: false,
            headers: {
                'Authorization': `Bearer ${access_token}`,
                'Cliente-Internet': `${sears_numero_internet}`,
                'Content-Type': 'application/json; charset=utf-8'
            }
        };
    }else{
        config = {
            method: 'get',
            url: apiURL,
            timeout: TIMEOUT_TIME,
            withCredentials: false,
            headers: {
                'Authorization': `Bearer ${access_token}`,
                'Content-Type': 'application/json; charset=utf-8'
            }
        };
    }

    return await axios(config)
    .then(res => {
        const {
            headers, 
            status, 
            data
        } = res
        return {
            'headers': headers,
            'statusCode': status,
            'data': data,
            'error': ''
        }
    })
    .catch(error =>{
        return {
            'headers': '',
            'statusCode': error.request.status,
            'data': error.request.response,
            'error': error.response.data.msg
        }
    })
}

export async function getCardSelected({cardending}){
    const apiURL = `${BASE_PATH_API}/credito-sears/v1/cards/${cardending}`
    const access_token = decodeStorage('access_token')

    const config = {
        method: 'get',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        headers: {
            'Authorization': `Bearer ${access_token}`,
            'Content-Type': 'application/json; charset=utf-8'
        }
    };

    return await axios(config)
    .then(res => {
        const {
            headers, 
            status, 
            data
        } = res
        return {
            'headers': headers,
            'statusCode': status,
            'data': data,
            'error': ''
        }
    })
    .catch(error =>{
        return {
            'headers': '',
            'statusCode': error.request.status,
            'data': error.request.response,
            'error': error.response.data.msg
        }
    })
}

export async function getCardEnding({cardComplete}){
    const apiURL = `${BASE_PATH_API}/credito-sears/v1/${cardComplete}/card-ending`
    const access_token = decodeStorage('access_token')
    const intnumber = decodeStorage('sears_numero_internet')

    const config = {
        method: 'get',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        headers: {
            'Authorization': `Bearer ${access_token}`,
            'intnumber': `${intnumber}`,
            'Content-Type': 'application/json; charset=utf-8'
        }
    };

    return await axios(config)
    .then(res => {
        const {
            headers, 
            status, 
            data
        } = res
        return {
            'headers': headers,
            'statusCode': status,
            'data': data,
            'error': ''
        }
    })
    .catch(error =>{
        return {
            'headers': '',
            'statusCode': error.request.status,
            'data': error.request.response,
            'error': error.response.data.msg
        }
    })
}

// Antiguo servicio para validar la tarjeta 
export async function postAddCardValidate(addCard){
    const apiURL = `${BASE_PATH_API}/credito-sears/v1/client-data`
    const access_token = decodeStorage('access_token')

    const raw = addCard

    console.log(raw)

    const config = {
        method: 'post',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        headers: {
            'Authorization': `Bearer ${access_token}`,
            'Content-Type': 'application/json; charset=utf-8'
        },
        data: raw
    };

    return await axios(config)
    .then(res => {
        const {
            headers, 
            status, 
            data
        } = res
        return {
            'headers': headers,
            'statusCode': status,
            'data': data,
            'error': ''
        }
    })
    .catch(error =>{
        return {
            'headers': '',
            'statusCode': error.request.status,
            'data': error.request.response,
            'error': error.response.data.msg
        }
    })
}

 /* --------------------- */

// Servicio para pago express
export async function postOtherCards(card){
    let apiURL
    if(STAGE_DIRNAME === 'dev'){
        apiURL = `${BASE_PATH_API_DEV.creditoServices}/credito-sears/v1/other-cards/get`
    }else{
        apiURL = `${BASE_PATH_API}/credito-sears/v1/other-cards/get`
    }

    const access_token = decodeStorage('access_token')
    //const sears_numero_internet = decodeStorage('sears_numero_internet')
    const sears_numero_internet = 'undefined'

    let config
    if(sears_numero_internet && sears_numero_internet != 'undefined'){
        config = {
            method: 'post',
            url: apiURL,
            timeout: TIMEOUT_TIME,
            withCredentials: false,
            headers: {
                'Authorization': `Bearer ${access_token}`,
                'Cliente-Internet': `${sears_numero_internet}`,
                'Content-Type': 'application/json; charset=utf-8'
            },
            data: card
        };
    }else{
        config = {
            method: 'post',
            url: apiURL,
            timeout: TIMEOUT_TIME,
            withCredentials: false,
            headers: {
                'Authorization': `Bearer ${access_token}`,
                'Content-Type': 'application/json; charset=utf-8'
            },
            data: card
        };
    }

    return await axios(config)
    .then(res => {
        const {
            headers, 
            status, 
            data
        } = res
        return {
            'headers': headers,
            'statusCode': status,
            'data': data,
            'error': ''
        }
    })
    .catch(error =>{
        return {
            'headers': '',
            'statusCode': error.request.status,
            'data': error.request.response,
            'error': error.response.data.msg
        }
    })
}

// Nuevo servicio para traer arreglo de cardending y cliente internet con usuarios sears
export async function getCard(){
    let apiURL
    if(STAGE_DIRNAME === 'dev'){
        apiURL = `${BASE_PATH_API_DEV.creditoServices}/credito-sears/v1/internet/card`
    }else{
        apiURL = `${BASE_PATH_API}/credito-sears/v1/internet/card`
    }

    const access_token = decodeStorage('access_token')

    const config = {
        method: 'get',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        headers: {
            'Authorization': `Bearer ${access_token}`,
            'Content-Type': 'application/json; charset=utf-8'
        }
    };

    return await axios(config)
    .then(res => {
        const {
            headers, 
            status, 
            data
        } = res
        return {
            'headers': headers,
            'statusCode': status,
            'data': data,
            'error': ''
        }
    })
    .catch(error =>{
        return {
            'headers': '',
            'statusCode': error.request.status,
            'data': error.request.response,
            'error': error.response.data.msg
        }
    })
}

// Nuevo servicio para asociar las tarjetas con usuarios sears
export async function postAddCard(addCard){
    let apiURL
    if(STAGE_DIRNAME === 'dev'){
        apiURL = `${BASE_PATH_API_DEV.creditoServices}/credito-sears/v1/internet/card`
    }else{
        apiURL = `${BASE_PATH_API}/credito-sears/v1/internet/card`
    }

    const access_token = decodeStorage('access_token')
    const raw = addCard

    const config = {
        method: 'post',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        headers: {
            'Authorization': `Bearer ${access_token}`,
            'Content-Type': 'application/json; charset=utf-8'
        },
        data: raw
    };

    return await axios(config)
    .then(res => {
        const {
            headers, 
            status, 
            data
        } = res
        return {
            'headers': headers,
            'statusCode': status,
            'data': data,
            'error': ''
        }
    })
    .catch(error =>{
        return {
            'headers': '',
            'statusCode': error.request.status,
            'data': error.request.response,
            'error': error.response.data.msg
        }
    })
}

// Lista de tarjetas asociadas al cliente sears
export async function getCardData(no_internet, cardending){
    let apiURL
    if(STAGE_DIRNAME === 'dev'){
        apiURL = `${BASE_PATH_API_DEV.creditoServices}/credito-sears/v1/cards/${cardending}?NoInternet=${no_internet}`
    }else{
        apiURL = `${BASE_PATH_API}/credito-sears/v1/cards/${cardending}?NoInternet=${no_internet}`
    }

    const access_token = decodeStorage('access_token')

    //console.log(raw)

    const config = {
        method: 'get',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        headers: {
            'Authorization': `Bearer ${access_token}`,
            'Content-Type': 'application/json; charset=utf-8'
        }
    };

    return await axios(config)
    .then(res => {
        const {
            headers, 
            status, 
            data
        } = res
        return {
            'headers': headers,
            'statusCode': status,
            'data': data,
            'error': ''
        }
    })
    .catch(error =>{
        return {
            'headers': '',
            'statusCode': error.request.status,
            'data': error.request.response,
            'error': error.response.data.msg
        }
    })
}

// Lista de tarjetas asociadas al cliente sears
export async function getCardList(){
    let apiURL
    if(STAGE_DIRNAME === 'dev'){
        apiURL = `${BASE_PATH_API_DEV.creditoServices}/credito-sears/v1/internet/card/list`
    }else{
        apiURL = `${BASE_PATH_API}/credito-sears/v1/internet/card/list`
    }

    const access_token = decodeStorage('access_token')

    //console.log(raw)

    const config = {
        method: 'get',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        headers: {
            'Authorization': `Bearer ${access_token}`,
            'Content-Type': 'application/json; charset=utf-8'
        }
    };

    return await axios(config)
    .then(res => {
        const {
            headers, 
            status, 
            data
        } = res
        return {
            'headers': headers,
            'statusCode': status,
            'data': data,
            'error': ''
        }
    })
    .catch(error =>{
        return {
            'headers': '',
            'statusCode': error.request.status,
            'data': error.request.response,
            'error': error.response.data.msg
        }
    })
}

// prende o apaga tarjetas
export async function getCardStatus({dataCard}){
    let apiURL
    let cardending = dataCard.cardending
    let no_internet = dataCard.no_internet
    let active = dataCard.active

    if(STAGE_DIRNAME === 'dev'){
        apiURL = `${BASE_PATH_API_DEV.creditoServices}/credito-sears/v1/cards/${cardending}?NoInternet=${no_internet}`
    }else{
        apiURL = `${BASE_PATH_API}/credito-sears/v1/cards/${cardending}?NoInternet=${no_internet}`
    }

    const access_token = decodeStorage('access_token')

    let row = ({
        active: active
    })

    const config = {
        method: 'post',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        headers: {
            'Authorization': `Bearer ${access_token}`,
            'Content-Type': 'application/json; charset=utf-8'
        },
        data: row
    };

    return await axios(config)
    .then(res => {
        const {
            headers, 
            status, 
            data
        } = res
        return {
            'headers': headers,
            'statusCode': status,
            'data': data,
            'error': ''
        }
    })
    .catch(error =>{
        return {
            'headers': '',
            'statusCode': error.request.status,
            'data': error.request.response,
            'error': error.response.data.msg
        }
    })
}